import { ArrowUpRight, Star, Trophy } from "lucide-react";
import { T } from "@/context/ContentContext";
import { useContact } from "@/hooks/useContact";

export function TrustBadges({ dark = true, className = "" }) {
  const CONTACT = useContact();
  const box = dark ? "bg-cream/10 border-cream/15 text-cream" : "bg-paper border-ink/10 text-ink";
  const sub = dark ? "text-cream/70" : "text-stone-600";
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="trust-badges">
      <div className={`inline-flex items-center gap-3 rounded-2xl border px-4 py-3 ${box}`} data-testid="badge-georgia-no1">
        <span className="grid place-items-center h-10 w-10 rounded-full bg-gold text-ink shrink-0"><Trophy className="h-5 w-5" /></span>
        <span className="leading-tight">
          <T k="badge.no1.title" className="block font-display font-extrabold text-lg">No. 1 for Georgia</T>
          <T k="badge.no1.text" className={`block text-xs ${sub}`}>Highest Georgia success rate in the market</T>
        </span>
      </div>
      <a href={CONTACT.googleReviews} target="_blank" rel="noreferrer" data-testid="badge-google-rating"
        className={`group inline-flex items-center gap-3 rounded-2xl border px-4 py-3 transition-colors duration-300 hover:border-gold ${box}`}>
        <span className={`grid place-items-center h-10 w-10 rounded-full shrink-0 font-display font-black text-lg ${dark ? "bg-paper text-ink" : "bg-ink text-cream"}`}>5</span>
        <span className="leading-tight">
          <span className="flex gap-0.5">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-4 w-4 text-gold fill-gold" />)}</span>
          <span className={`block text-xs mt-1 ${sub}`}><T k="badge.google.text">5-star rating on Google Maps</T> · <span className="underline underline-offset-2"><T k="badge.google.link">Read reviews</T></span></span>
        </span>
        <ArrowUpRight className="h-4 w-4 text-gold transition-transform duration-300 group-hover:rotate-45" />
      </a>
    </div>
  );
}
